export default __webpack_public_path__ + "static/media/myh5-hover.65e46442.svg";